<header class="header" role="banner">
  <div class="header__go-back-wrapper">
    <button
      type="button"
      class="button-transparent"
      *ngIf="isBookingRoute && currentStep && showBackBtn"
      (click)="goBack()"
      aria-label="Go back to previous step"
    >
      <div class="go-back-icon-wrapper">
        <svg class="icon">
          <use href="assets/images/redesign/icons-sprite.svg#arrow-left-icon" />
        </svg>
      </div>

      <span class="body-4--secondary desktop-only">
        {{ "previous" | l10n }}
      </span>
    </button>
  </div>

  <div
    role="status"
    aria-live="polite"
    class="header__step-info"
    *ngIf="isBookingRoute && currentStep"
  >
    <span class="header__step-title">
      {{ "onDemandWorkspace" | l10n }}
    </span>

    <span>
      ({{ "stepOfSteps" | l10n: { currentStep: (currentStep?.index + 1), totalSteps: totalSteps, noTransform: true } }})
    </span>
  </div>

  <div class="header__phone-wrapper">
    <a aria-label="contact-us" class="button-transparent link-button" href="tel:{{phoneNumber}}">
      <svg class="icon">
        <use href="assets/images/redesign/icons-sprite.svg#phone-icon" />
      </svg>
      <span class="text">
        <span class="body-5--primary need-help">{{ "needHelp" | l10n }}</span>
        <span class="body-4--secondary">{{ phoneNumber }}</span>
      </span>
    </a>
  </div>
</header>
